import { useTrackingConsent } from "@/hooks/shared/tracking-consent/useTrackingConsent";
import React, { useCallback, useEffect } from "react";
import ReactGa from "react-ga4";

export const GoogleAnalyticsProvider = ({ children }: { children: React.ReactNode }) => {
    const [error, setError] = React.useState<Error | null>(null);

    const { canTrack } = useTrackingConsent();

    const handleInitialize = useCallback(() => {
        if (!ReactGa.isInitialized) {
            try {
                ReactGa.initialize("G-5K9FDM17WW", {});
            } catch (error) {
                console.error("Error initializing Google Analytics:", error);
                setError(error as Error);
            }
        }
    }, [ReactGa.isInitialized, setError]);

    useEffect(() => {
        // Stop on any error
        if (error) return;
        // Stop if already initialized
        if (ReactGa.isInitialized) return;
        // Only initialize if user has given consent
        if (canTrack) {
            handleInitialize();
        }
    }, [error, canTrack, handleInitialize, ReactGa.isInitialized]);

    return <>{children}</>;
};
